import {useQuery} from "@tanstack/react-query";
import {
  fetchAdministrativeUnitOverview
} from "app/edozvola/administrative-unit-overview/service/administrative-unit-overview.service";
import {PaginationState} from "app/shared/pagination/pagination.model";
import {
  AdministrativeUnitOverviewFilterDto
} from "app/edozvola/administrative-unit-overview/model/administrative-unit-overview.model";

export const fetchAdministrativeUnitOverviewQuery = (pagination: PaginationState, filterDto:AdministrativeUnitOverviewFilterDto) => {
  return useQuery({
    queryKey: ['administrative-unit-overview', { ...pagination }, {...filterDto}],
    queryFn: () => fetchAdministrativeUnitOverview(pagination, filterDto)
  });
};
